import axios from 'axios'

import { get } from '@bigyouth/base'

import emitter from '../utils/emitter'

import { FORM_ACTIONS } from './formValidation'

export default {
  name: 'home-form',

  options: {
    localesKey: 'homeForm',
    endpoint: 'https://statement.bigyouth.fr/api/appointment',
    method: 'post',
  },

  ui: {
    'inputs[]': 'select, input, textarea',
    successLabel: '[js-home-form-success]',
    errorLabel: '[js-home-form-error]',
  },

  componentDidMount () {
    emitter.on(FORM_ACTIONS.SUBMIT, this.handleFormSubmit)
  },

  handleFormSubmit (options) {
    if (this.props.formId === options.formId) {
      // Create an object containing all the inputs, with the names as keys.
      const data = this.ui.inputs.reduce((acc, { name, value }) => ({
        ...acc,
        [name]: value,
      }), {})

      axios({
        url: this.options.endpoint,
        method: this.options.method,
        data,
      })
        .then(this.handleFormSuccess.bind(this))
        .catch(this.handleFormError.bind(this))
    }
  },

  handleFormSuccess () {
    this.ui.successLabel.classList.remove('is-hidden')
    this.ui.errorLabel.classList.add('is-hidden')

    this.ui.inputs.forEach((input) => {
      input.value = ''

      if (input.tagName === 'SELECT') {
        input.selectedIndex = 0
        input.dispatchEvent(new Event('change'))
      }
    })
  },

  handleFormError () {
    this.ui.successLabel.classList.add('is-hidden')
    this.ui.errorLabel.classList.remove('is-hidden')
  },

  hideInputWrapper (target) {
    target.setAttribute('hidden', '')
    const targetInput = get('input', target)

    if (targetInput) {
      targetInput.removeAttribute('required')
      targetInput.removeAttribute('js-required-field')
    }
  },

  showInputWrapper (target) {
    target.removeAttribute('hidden')
    const targetInput = get('input', target)

    if (targetInput) {
      targetInput.setAttribute('required', '')
      targetInput.setAttribute('js-required-field', '')
    }
  },
}
